import { useNavigate } from 'react-router-dom';

export default function Navigation() {
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      const res = await fetch('/api/auth/logout', {
        method: 'POST'
      });
      
      if (!res.ok) {
        throw new Error('Logout failed');
      }
      
      navigate('/welcome');
    } catch (error) {
      console.error('Logout error:', error);
    }
  };

  return (
    <nav className="border-b border-white/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-16">
          <div className="flex-shrink-0 flex items-center space-x-2">
            <div className="h-8 w-8 bg-gradient-to-br from-orange-500 to-purple-600 rounded-lg" />
            <span className="text-xl font-semibold text-white">CF Shortcuts</span>
          </div>
          <div className="flex items-center">
            <button
              onClick={handleLogout}
              className="text-white/80 hover:text-white transition-colors px-4 py-2"
            >
              Logout
            </button>
          </div>
        </div>
      </div>
    </nav>
  );
} 